import { Component, Input } from '@angular/core';
import { UserPreview } from '../../interfaces/user-preview.interface';

@Component({
    selector: 'app-step-description',
    templateUrl: 'step-description.component.html',
    styleUrls: ['step-description.component.scss']
})
export class StepDescriptionComponent {

    @Input() readonly description: string;
    @Input() readonly extraDescription: string;
    @Input() readonly employee?: UserPreview;
    @Input() readonly showName = false;

    public parsedDescription(description: string): string {
        return description.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
}
